import React, { useState } from "react";
import { MediaFile } from "src/api/public-types";
import { BaseButton } from "src/components";
import BaseFileUpload from "src/components/mediaFile/BaseFileUpload";
import { useModal } from "src/recoil/modalState/hook";

/**
 * 이용자 엑셀 업로드 모달
 * @param handleClickExcelLoad 확인 버튼 클릭시 호출되는 함수
 * @returns
 */
const ExcelUploadModal = ({ handleClickExcelLoad }: { handleClickExcelLoad: (blobUrl?: string) => Promise<void> }) => {
  const [medias, setMedias] = useState<MediaFile[]>([]);

  const { setAbstractModalZ1 } = useModal();

  return (
    <>
      <section className="base-abstract-modal__title buttom-list-wrap border-bottom">
        <h1>이용자 엑셀 업로드</h1>
        <ul className="base-list">
          <li className="font14">제공하는 엑셀 가이드 파일만 업로드 가능합니다.</li>
        </ul>
      </section>
      <section className="base-abstract-modal__contents px30">
        {/* // 테이블 없을때 px30 추가 */}
        <section className="base-abstract-modal__contents-subtitle mt0">
          <h2>Step 1. 양식 다운로드</h2>
        </section>
        <div className="flex-row flex-start-start">
          <div className="w145 h40 flex-row flex-center-start gap8">
            <span className="base-excel"></span>
            <span className="font14 font-weight-semibold text-primary3">엑셀 가이드 파일</span>
          </div>
          <BaseButton
            className="color-white icon-download "
            title={"다운로드"}
            onClick={() => {
              //파일 다운로드
              const link = document.createElement("a");
              link.href = `${process.env.REACT_APP_S3_CONTENT_BASEURL}ctrl-room/excel/user_bulk_upload_template_v2.xlsx`;
              link.click();
            }}
          />
        </div>
        <section className="base-abstract-modal__contents-subtitle mt0">
          <h2>Step 2. 파일 업로드</h2>
        </section>

        <div className="flex-row flex-start-start">
          <div className="w145 h40 flex-row flex-center-start">
            <p className="required font14 font-weight-semibold text-primary3 ml11">첨부파일{medias && ` (${medias.length}/1)`}</p>
          </div>

          <BaseFileUpload
            disabled={medias.length >= 1}
            limit={1}
            maxWidth={335}
            fileList={medias}
            accept=".xlsx, .numbers"
            setFiles={setMedias}
            mode="ul-none"
            BaseButtonClassName="icon-upload"
          />
        </div>
      </section>
      <section className="base-abstract-modal__btn-wrap">
        <BaseButton title={"취소"} className="color-white" onClick={() => setAbstractModalZ1({ isOpen: false })} />
        <BaseButton
          disabled={medias.length === 0}
          title={"확인"}
          onClick={() => {
            handleClickExcelLoad(medias?.[0]?.blobUrl);
            setAbstractModalZ1({ isOpen: false });
          }}
        />
      </section>
    </>
  );
};

export default ExcelUploadModal;
